/**
 * @fileoverview PUT handler for the "/engagement/segments/:segment_id" endpoint
 */
import type { SuppressionListErrors } from "@dashboardApi/apis/engagementSegmentsMarkAsArchived/types";

import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsSegmentIdCacheKeys } from "./constants";
import type { PutEngagementSegmentsSegmentIdProps, EngagementSegmentPutResult } from "./types";

export const putEngagementSegmentsSegmentId = reactQueryMutationAdapter(
  engagementSegmentsSegmentIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<SuppressionListErrors>()(
    (props: PutEngagementSegmentsSegmentIdProps): Promise<EngagementSegmentPutResult> => {
      return fetch(
        `/engagement/segments/${props.segment_id}`,
        "PUT",
        props,
        {},
        { propagateFetchRequestError: false }
      );
    }
  )
);
